import React from 'react'
import { IComponent } from '../../utils/type/dynamic-rendering.interfaces';

import { ColumnViewParam } from '../GroupParams/ColumnViewParam/ColumnViewParam';
import { GroupSettingBase } from '../GroupParams/GroupSettingBase/GroupSettingBase';
import { HintWrap } from '../GroupParams/HintWrap/HintWrap';
import { LineParam } from '../GroupParams/LineParam/LineParams';
import { SectionOpening } from '../GroupParams/SectionOpening/SectionOpening';
import { SectionParams } from '../GroupParams/SectionParams/SectionParams';
import { TwoLineParams } from '../GroupParams/TwoLineParams/TwoLineParams';
import { OptionsSide } from '../OptionsSide/OptionsSide';

import { SideCheckViewSetting } from '../SideCheckViewSetting/SideCheckViewSetting';
import { ColorSelectionSection } from '../StandartComponent/ColorSelectionSection/ColorSelectionSection';
import { GroupCupola } from '../StandartComponent/GroupCupola/GroupCupola';
import { ImgRadio } from '../StandartComponent/ImgRadio/ImgRadio';
import { InputStandard } from '../StandartComponent/InputStandard/InputStandard';
import { ListParams } from '../StandartComponent/ListParams/ListParams';
import { OrientationSides } from '../StandartComponent/OrientationSides/OrientationSides';
import { PorchSides } from '../StandartComponent/PorchSides/PorchSides';
import { PorchSidesColor } from '../StandartComponent/PorchSidesColor/PorchSidesColor';
import { RadioStandard } from '../StandartComponent/RadioStandart/RadioStandart';
import { RadioSwitcher } from '../StandartComponent/RadioSwitcher/RadioSwitcher';
import { SelectStandard } from '../StandartComponent/SelectStandard/SelectStandard';
import { SwitchStandard } from '../StandartComponent/SwitchStandard/SwitchStandard';


type DistributeComponentsT = IComponent & { parentKeySection?: unknown }

export const DistributeComponents: React.FC<DistributeComponentsT> = ({ ...props }) => {

    const { parentKeySection, type, data } = props;
    let params: any = { ...data };




    switch (type) {
        case 'LineParamInput': {

            return (
                <LineParam parentKeySection={parentKeySection} {...params} > <InputStandard parentKeySection={parentKeySection} {...params} /></LineParam>
            )
        }

        case 'LineParamRadio': {
            return (
                <LineParam parentKeySection={parentKeySection} {...params} key={data['id']} > <RadioStandard parentKeySection={parentKeySection} {...data} /></LineParam>
            )
        }
        case 'LineParamSelect': {

            return (
                <LineParam parentKeySection={parentKeySection} {...params} > <SelectStandard parentKeySection={parentKeySection} {...params} /></LineParam>
            )
        }

        case 'GroupSetting': {
            const embeddedView: IComponent[] = params['embeddedView']
            return (
                <SectionParams parentKeySection={parentKeySection} {...params} >
                    {embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                        return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                    })}
                </SectionParams>
            )
        }
        case 'TwoLineParams': {
            const embeddedView: IComponent[] = params['embeddedView']
            return (
                <TwoLineParams parentKeySection={parentKeySection} {...params} >
                    {embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                        return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                    })}
                </TwoLineParams>
            )
        }
        case 'SettingOpening': {
            const embeddedView: IComponent[] = params['embeddedView']
            return (
                <SectionOpening parentKeySection={parentKeySection} {...params} >
                    {embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                        return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                    })}
                </SectionOpening>
            )
        }
        case 'ListParams': {
            return (
                <ListParams parentKeySection={parentKeySection} {...params} > </ListParams>
            )
        }
        case 'ColumnViewParam': {
            return (
                <ColumnViewParam parentKeySection={parentKeySection} {...params} >
                    <SelectStandard parentKeySection={parentKeySection} {...params} />
                </ColumnViewParam>
            )
        }
        case 'SwitchStandardST': {
            return (
                <SwitchStandard parentKeySection={parentKeySection} {...params} />
            )
        }
        case 'GroupSettingBase': {
            const embeddedView: IComponent[] = params['embeddedView']
            return (
                <GroupSettingBase parentKeySection={parentKeySection} {...params}>
                    {embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                        return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                    })}
                </GroupSettingBase>
            )
        }
        case 'LineParamGT': {
            const embeddedView: IComponent[] = params['embeddedView']
            return (
                <LineParam parentKeySection={parentKeySection} {...params} key={data['id']} >  {embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                    return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                })}</LineParam>
            )
        }
        case "PorchSidesST": {
            return (
                <PorchSides parentKeySection={parentKeySection} {...params} key={data['id']} > </PorchSides>
            )
        }
        case 'PorchSidesColorST': {
            return (
                <PorchSidesColor parentKeySection={parentKeySection} {...params} key={data['id']} > </PorchSidesColor>
            )
        }
        case 'ImgRadioST': {
            return (
                <ImgRadio parentKeySection={parentKeySection} {...params} key={data['id']} > </ImgRadio>
            )
        }
        case 'OrientationSidesST': {
            return (
                <OrientationSides parentKeySection={parentKeySection} {...params} key={data['id']} > </OrientationSides>
            )
        }
        case 'SideCheckViewSettingST': {
            return (
                <SideCheckViewSetting parentKeySection={parentKeySection} {...params} key={data['id']} > </SideCheckViewSetting>
            )
        }
        case 'GroupCupolaST': {
            return (
                <GroupCupola parentKeySection={parentKeySection} {...params} key={data['id']} > </GroupCupola>
            )
        }
        case 'OptionsSideGroup': {
            const embeddedView: IComponent[] = params['embeddedView'];

            return (
                <OptionsSide parentKeySection={parentKeySection} {...params}  >
                    {embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                        console.log('test_1');

                        return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                    })}
                </OptionsSide>
            )
        }
        case 'HintWrapGroupGT': {
            const embeddedView: IComponent[] = params['embeddedView'];

            return (
                <HintWrap parentKeySection={parentKeySection} {...params}  >
                    {embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                        return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                    })}
                </HintWrap>
            )
        }
        case 'RadioSwitcherST': {

            return (
                <RadioSwitcher parentKeySection={parentKeySection} {...params} key={data['id']} > </RadioSwitcher>
            )
        }
        case 'ColorSelectionSectionST': {
            const embeddedView: IComponent[] = params['embeddedView'];

            return (
                <ColorSelectionSection parentKeySection={parentKeySection} {...params} key={data['id']} >
                    {Array.isArray(embeddedView) && embeddedView.length > 0 && embeddedView.map((setting: IComponent) => {
                        return (<DistributeComponents parentKeySection={parentKeySection} key={setting['data']['id']} {...setting} />)
                    })}
                </ColorSelectionSection>
            )
        }

        default:
            return (<div>default </div>)
    }
}